module.exports = {
    apiKey: "AIzaSyCcgSiNl4vat7YjLIEg3wmyE-5d0k5AF5c",
    authDomain: "catalogdom.firebaseapp.com",
    projectId: "catalogdom",
    storageBucket: "catalogdom.appspot.com",
    messagingSenderId: "510698070532",
    appId: "1:510698070532:web:4428a5f10d1a3848258b51",
    measurementId: "G-VL3N8QXR2Y"
};